<template>
  <div class="p-grid dashboard">
    <div class="p-col-12">
      <Toast />

      <div class="card">
        <DataTable
          :value="items"
          :paginator="true"
          class="p-datatable-outlets"
          :rows="10"
          data-key="doc_number"
          :filters="filters1"
          :loading="loading1"
        >
          <h5>
            <b>Daftar Mutasi Keluar Barang</b>
          </h5>
          <template #header>
            <div class="table-header">
              <!-- <div v-if="loading.upload == false">
                <router-link
                  :to="{
                    name: 'print-receive-list',
                    query: {
                      outlet_id: user.outlet_id
                    }
                  }"
                  target="_blank"
                >
                  <Button
                    label="Print"
                    icon="pi pi-print"
                    class="p-button-success"
                    style="margin-bottom: 0.2rem"
                  />
                </router-link>
              </div> -->
              <div v-if="loading.upload == true">
                <button type="submit" class="btn btn-primary" :disabled="true">
                  Uploading...
                  <span>
                    <i
                      class="pi pi-spin pi-spinner"
                      style="font-size: 12px"
                    ></i>
                  </span>
                </button>
              </div>
              <div class="p-input-icon-left p-col-5 p-md-3 p-lg-2">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters1['doc_number']"
                  placeholder="Cari Nomor Bon"
                />
              </div>
              <div class="p-input-icon-left p-col-5 p-md-3 p-lg-2">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters1['doc_date']"
                  placeholder="Cari Tanggal Bon"
                />
              </div>
              <div class="p-col-5 p-md-3 p-lg-2">
                <AutoComplete
                  placeholder="Toko"
                  id="Outlet"
                  :dropdown="true"
                  :multiple="false"
                  v-model="selectedOutlet"
                  :suggestions="autoFilteredValue"
                  field="name"
                  @complete="searchOutlets($event)"
                  @input="chooseOutlets()"
                />
              </div>
              <div class="p-col-5 p-md-3 p-lg-2">
                <AutoComplete
                  placeholder="Status"
                  :dropdown="true"
                  v-model="filter.status"
                  field="name"
                  :suggestions="list_status"
                  @complete="filterStatus"
                ></AutoComplete>
              </div>
              <div class="p-col-5 p-md-3">
                <button
                  class="btn btn-primary"
                  @click="filterOutletAndStatus"
                  style="width: 100%"
                >
                  Cari
                </button>
              </div>
            </div>
          </template>
          <template #empty>Data tidak tersedia.</template>
          <template #loading>Sedang mengambil data. Mohon tunggu.</template>
          <Column field="doc_number" header="Nomor Bon">
            <template #body="slotProps">
              {{ slotProps.data.doc_number }}
            </template>
          </Column>
          <Column field="doc_date" header="Tanggal Bon">
            <template #body="slotProps">
              <span>
                {{ slotProps.data.doc_date }}
              </span>
            </template>
          </Column>

          <Column header="Total Barang">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_item }}</span>
            </template>
          </Column>
          <Column header="Total Qty">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_qty }}</span>
            </template>
          </Column>
          <Column header="Total Harga">
            <template #body="slotProps">
              <span>{{ slotProps.data.total_price | currency }}</span>
            </template>
          </Column>
          <Column header="Status">
            <template #body="slotProps">
              <div v-if="slotProps.data.status == 1">
                <span style="color: green; font-weight: bold">Confirmed</span>
              </div>
              <div v-else-if="slotProps.data.status == 2">
                <span style="color: blue; font-weight: bold">Rejected</span>
              </div>
              <div v-else>
                <span style="color: red; font-weight: bold">Pending</span>
              </div>
            </template>
          </Column>
          <Column
            headerStyle="width: 12rem"
            bodyStyle="text-align: center; overflow: visible"
          >
            <template #body="slotProps">
              <div>
                <router-link
                  :to="{
                    name: 'report-mutation-out-detail',
                    query: { doc_number: slotProps.data.doc_number }
                  }"
                >
                  <Button
                    type="button"
                    icon="pi pi-eye"
                    class="p-button-rounded p-mr-2"
                  ></Button>
                </router-link>
                <Button
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-rounded p-button-warning"
                  @click="confirmDelete(slotProps.data)"
                  v-if="
                    slotProps.data.status === 0 && user.role == 'OUTLET_MANAGER'
                  "
                ></Button>
              </div>
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const moment = require('moment')
export default {
  data() {
    return {
      moment: moment,
      filters1: {},
      doc_number: '',
      loading1: true,
      expandedRows: [],
      items: null,
      deleteDialog: false,
      activeDialog: false,
      outlets: [],
      selectedOutlets: null,
      selectedOutlet: { id: '', code: '', name: '' },
      autoFilteredValue: [],
      list_status: [],
      outletInbound: {},
      filter: {
        status: ''
      },
      loading: {
        deleteButton: false,
        activeButton: false,
        upload: false
      }
    }
  },
  computed: mapState(['user', 'isAuthenticated']),

  mounted() {
    this.getListMutationItems()
    this.getListOutlets()
  },
  methods: {
    getListMutationItems() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds`)
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.items = response.data.data.outlet_inbounds
          } else {
            console.error('gagal get')
          }
        })
    },

    filterOutletAndStatus() {
      let out_id = this.selectedOutlet.id ? this.selectedOutlet.id : ''
      let status = this.filter.status ? this.filter.status.code : ''
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/outlet-inbounds?status=${status}&outlet_id=${out_id}`
        )
        .then(response => {
          this.loading1 = false
          if (response.status === 200) {
            this.items = response.data.data.outlet_inbounds
          } else {
            console.error('gagal get')
          }
        })
    },

    searchOutlets(event) {
      this.autoFilteredValue = this.selectedOutlets.filter(item => {
        return (
          item.code.toLowerCase().includes(event.query.toLowerCase()) ||
          item.name.toLowerCase().includes(event.query.toLowerCase())
        )
      })
    },

    filterStatus() {
      this.list_status = [
        {
          name: 'Pending',
          code: '0'
        },
        {
          name: 'Confirmed',
          code: '1'
        }
      ]
    },

    chooseOutlets() {},
    getListOutlets() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlets`)
        .then(response => {
          if (response.status === 200) {
            this.selectedOutlets = response.data.data.outlets
          } else {
            console.error('gagal get')
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

/deep/ .p-datatable.p-datatable-outlets {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-outlets .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  /deep/ .p-datatable {
    &.p-datatable-outlets {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}

::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
